export default {"src":"/_next/static/media/InsuranceGroup-2_horizontal.16b4a424.svg","height":210,"width":1066};